module.exports = __webpack_public_path__ + "img/idcard_fanmian.19bc8fea.png";